// libs
import classNames from 'classnames'
import * as React from 'react'

// components
import { SvgIcon, SvgIconName } from 'src/components/icons/svg-icon'
import ShareItemSegment from 'src/components/item_segment/layouts/share/share'

// interfaces / constants
import {
  IShareTarget,
  ShareTargetName,
  shareTexts,
  ShareTrackingAction
} from 'src/components/share/lib/share_targets'
import { CLASS_PREFIX } from 'src/constants/'

import './share_targets.scss'

const cls = CLASS_PREFIX + 'share-targets'
const clsIcon = CLASS_PREFIX + 'share-round-icon'
const clsMobileOnly = cls + '--mobile-only'

type ShareIconName = ShareTargetName | 'link'

const ICONS: Record<ShareIconName, SvgIconName> = {
  email: 'Share/email',
  facebook: 'Share/facebook',
  link: 'Share/link',
  linkedin: 'Share/linkedin',
  whatsapp: 'Share/whatsapp'
}

export const ShareRoundIcon: React.FC<{ name: ShareIconName }> = ({ name }) => (
  <span className={classNames(clsIcon, `${clsIcon}--${name}`)}>
    <SvgIcon name={ICONS[name]} size={24} />
  </span>
)

interface IProps {
  targets: IShareTarget[];
  onTarget: (action: ShareTrackingAction) => void;
  onCopyLink: () => void;
}

/**
 * The share targets as a row of round icons with captions, the content of the share popover.
 */
export const ShareTargetRow: React.FC<IProps> = ({ targets, onTarget, onCopyLink }) => (
  <ul className={cls + '__row'}>
    {targets.map((target) => (
      <li key={target.name} className={classNames({ [clsMobileOnly]: target.mobileOnly })}>
        <a
          className={cls + '__target'}
          href={target.href}
          target='_blank'
          rel='noopener noreferrer'
          aria-label={target.label}
          onClick={() => onTarget(target.trackingAction)}
        >
          <ShareRoundIcon name={target.name} />
          <span className={cls + '__caption'}>{target.caption}</span>
        </a>
      </li>
    ))}
    <li>
      <button type='button' className={cls + '__target'} aria-label={shareTexts.copyLink} onClick={onCopyLink}>
        <ShareRoundIcon name='link' />
        <span className={cls + '__caption'}>{shareTexts.link}</span>
      </button>
    </li>
  </ul>
)

/**
 * The same share targets as menu entries, for the "more" menus of detail page and group.
 */
export const ShareTargetList: React.FC<IProps> = ({ targets, onTarget, onCopyLink }) => (
  <>
    {targets.map((target) => (
      <ShareItemSegment
        key={target.name}
        className={classNames({ [clsMobileOnly]: target.mobileOnly })}
        iconElement={<ShareRoundIcon name={target.name} />}
        label={target.caption}
        navigation={{ onClick: () => onTarget(target.trackingAction), target: '_blank', url: target.href }}
      />
    ))}
    <ShareItemSegment
      iconElement={<ShareRoundIcon name='link' />}
      label={shareTexts.copyLink}
      navigation={{ onClick: onCopyLink }}
    />
  </>
)
